var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 12.5H35.8333C39.3337 12.5 41.0838 12.5 42.4208 13.1812C43.5968 13.7804 44.5529 14.7365 45.1521 15.9126C45.8333 17.2495 45.8333 18.9997 45.8333 22.5V37.5H22.9167M14.5833 12.5C19.1857 12.5 22.9167 16.231 22.9167 20.8333V37.5M14.5833 12.5C9.98096 12.5 6.25 16.231 6.25 20.8333V37.5H22.9167M35.4167 6.25H29.1667V25M20.8333 37.5V43.75H29.1667V37.5M14.5833 25H14.6042",
    stroke: "#182B43",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.4ddee6ca09da39df5fbb9584febcd324.svg";
export { ForwardRef as ReactComponent };